export default __webpack_public_path__ + "static/media/carousel-placeholder2.adbba757.gif";